import { useParams } from 'react-router-dom';
import { useAuth } from '../../shared/context';
import { CallsPage } from './CallsPage';
import { LenderCallsPage } from './LenderCallsPage';

export const Calls: React.FC = () => {
	var auth = useAuth();
	const { guid } = useParams<'guid'>();

	return auth.currentUser.isBankUser ? (
		<LenderCallsPage dataRoomGuid={guid} currentUser={auth.currentUser} />
	) : (
		<CallsPage dataRoomGuid={guid} currentUser={auth.currentUser} />
	);
};
